import { Component, Input, OnInit } from '@angular/core';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Course, CoursesService } from '../courses.service';

@Component({
    selector: 'app-course-item',
    templateUrl: './course-item.component.html',
    styleUrls: ['./course-item.component.css'],
    standalone: false
})
export class CourseItemComponent implements OnInit {

  @Input() course: Course;
  @Input() orgTypeId: number;
  @Input() index: number;

  public choosenLanguage = 'it';
  public icons: { [name: string]: any } = {
    'faEdit': faEdit,
    'faTrashAlt': faTrashAlt
  };

  constructor(private _coursesService: CoursesService) { }

  ngOnInit(): void {
    if (this.orgTypeId === 2) {
      if (this.course.description_it) {
        this.choosenLanguage = 'it';
        return;
      }
      if (this.course.description_de) {
        this.choosenLanguage = 'de';
        return;
      }
      if (this.course.description_en) {
        this.choosenLanguage = 'en';
        return;
      }
    }
  }

  deleteCourseButtonClick() {
    this._coursesService.courseDeleteIndex.next(this.index);
  }

  updateCourseButtonClick() {
    this._coursesService.courseUpdateIndex.next(this.index);
  }

}
